import React from 'react'

import { useTranslation } from 'language/translator'

import Button from 'components_new/atoms/Button'

import { ISelectEntity } from 'types/GlobalEntities'

interface TopbarActionsProps {
  edit: boolean
  entity: ISelectEntity | null
  onToggleEdit: () => void
}

const TopbarActions = (props: TopbarActionsProps) => {
  const { edit, entity, onToggleEdit } = props

  const { t } = useTranslation()

  if (!entity) return null

  return (
    <Button onClick={onToggleEdit} variant={edit ? 'contained' : 'text'}>
      {edit ? t('global', 'done') : t('global', 'edit')}
    </Button>
  )
}

export default TopbarActions
